import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import TextLink from 'LuxKit/TextLink'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { take } from 'lib/array/arrayUtils'
import { Fragment, useMemo } from 'react'
import styled from 'styled-components'

const Wrapper = styled(Group)`
  overflow: hidden;

  > * {
    flex-shrink: 0;
  }

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const Link = styled(TextLink)`
  display: block;
  white-space: nowrap;

  &:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

interface Props {
  items: Array<App.BreadcrumbItem>
}

function TopMobileRelatedTravelItems({ items }: Props) {
  const nonCurrentItems = useMemo(() => take(items, items.length - 1), [items])

  return (
    <Wrapper gap={8} direction="horizontal" verticalAlign="center">
      {nonCurrentItems.map((item, index) => <Fragment key={index}>
        {index !== 0 && <LineAngleRightIcon size="XS" />}
        <Link
          weight="regular"
          size="caption"
          to={item.url}
        >
          {item.text}
        </Link>
      </Fragment>)}
    </Wrapper>
  )
}

export default TopMobileRelatedTravelItems
